"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKicadProjectFile = validateKicadProjectFile;
const Utils_1 = require("@cadstrom/sigma-engine-shared/dist/Utils");
const kicad_file_type_1 = require("./kicad-file-type");
function validateKicadProjectFile(filename, fileContents) {
    const parsed = JSON.parse(fileContents);
    if (filename.endsWith(kicad_file_type_1.KicadFileType.KicadProject)) {
        const projectSettings = parsed;
        const referencedFiles = [
            ...(0, Utils_1.toArray)(projectSettings.pcbnew?.page_layout_descr_file),
            ...(0, Utils_1.toArray)(projectSettings.schematic?.ngspice?.workbook_filename),
            ...(0, Utils_1.toArray)(projectSettings.schematic?.page_layout_descr_file),
        ].filter(Boolean);
        return {
            version: projectSettings.meta?.version?.toString(),
            referencedFiles,
            metadata: {},
        };
    }
    if (filename.endsWith(kicad_file_type_1.KicadFileType.KicadProjectLocalSettings)) {
        const projectSettings = parsed;
        const referencedFiles = [];
        return {
            version: projectSettings.meta?.version?.toString(),
            referencedFiles,
            metadata: {},
        };
    }
    throw new Error(`Invalid project file: ${filename}`);
}
//# sourceMappingURL=projectValidation.js.map